exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#queueSelect[data-v-63177f62] {\n    width: 20%;\n}\n.card-status-center[data-v-63177f62]{\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n", ""]);

// exports
